import { useCallback, useState } from 'react';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import certificateLogo from '../../assets/images/bage-removebg.png';

import Link from '../Link/Link';
import { checkIfEligible } from '../../api/Exam/eligible.api';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import './navbar.css';
import {
  SET_EXAM_ELIGIBILITY,
  SET_IS_AUTH,
  SET_PROFILE_CODE,
} from '../../redux/reducers/userSlice';
import { useId } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import whatsapp from '../../../src/assets/images/whats.png';
import { getProfileState } from '../../utils/functions/profileTracking';
import {
  InstanceWithAuth,
  PROFILE_TRACKER,
  POS_TOKEN_LOGIN,
  USER_PROFILE,
  USER_LEAD,
  LEAD_KPI,
  InstanceWithNoAuth,
} from '../../api/routes';
import { getSessionToken, setSessionAuth } from '../../utils/session';

const Navbar = (props) => {
  const [query] = useSearchParams();
  const posToken = query.get('token');
  const navigate = useNavigate();
  const location = useLocation();
  const record = location.state?.record;

  const [loading, setLoading] = useState(true);
  const [posData, setPosData] = useState();
  const InConstruction = true;
  useEffect(() => {
    const login = async () => {
      if (posToken) {
        let formData = new FormData();
        formData.append('pos_token', posToken);
        // setLoading(true)
        try {
          let res = await InstanceWithNoAuth.post(POS_TOKEN_LOGIN, formData);
          const posData = res.data;
          setPosData(posData);

          localStorage.setItem('posDetails', JSON.stringify(posData));
          if (res.status === 200) {
            const { token } = res.data;
            setSessionAuth(token);
            reduxDispatch(SET_IS_AUTH(true));

            // auth headers to calculated as soon as successful response is received so that
            // axios instance with auth works properly and as expected
            InstanceWithAuth.defaults.headers.Authorization = `Bearer ${getSessionToken()}`;

            let trackerRes = await InstanceWithAuth.get(PROFILE_TRACKER, {
              Authorization: `Bearer ${token.access}  `,
            });
            let flag;
            if (trackerRes.status === 200) {
              let { data } = trackerRes;
              flag = await data.flag;
            }
            await InstanceWithAuth.get(USER_PROFILE, {
              Authorization: `Bearer ${token.access}  `,
            })
              .then((res) => {
                const userData = res.data;
              })
              .catch((err) => {
                console.error(err);
              });

            await InstanceWithAuth.get(LEAD_KPI, {
              Authorization: `Bearer ${token.access}  `,
            })
              .then((res) => {
                //
              })
              .catch((err) => {
                console.error(err);
              });
            reduxDispatch(SET_PROFILE_CODE(flag));
            // if (from) {
            //   navigate(from);
            // }
            // if (flag === 1) {
            //   navigate('/not-found');
            // } else
            if ((await flag) >= 0) {
              navigate(getProfileState(flag), {
                state: { flag: flag, userId: {} },
              });
            }
          }
        } catch (err) {
          if (err.response) {
            console.error(err);
          }
        }
      } else {
        setLoading(false);
      }
    };
    login();
  }, [posToken]);

  const userDetails = sessionStorage.getItem('userprofile');
  const userData = sessionStorage.getItem('userData');

  const storedObject = JSON.parse(userDetails);

  const storedUserData = JSON.parse(userData);
  const { rounded = true, toggle } = props;

  /**
   * for examStatusCode =>
   * 0: training not completed
   * 1: training completed, eligible for exam
   * -1: failure in api for exam status fetch
   * this list can be extended for different use cases
   */
  const { auth: isAuth, profileTrackerCode } = useSelector(
    (state) => state.user
  );
  const reduxDispatch = useDispatch();
  const prefix = useId();

  const checkExamStatus = useCallback(
    async (e) => {
      let examStatus = null;

      if (isAuth) {
        const { data, status } = await checkIfEligible();

        if (status === 200) {
          examStatus = 'flag' in (await data) ? data.flag : 0;
        } else {
          examStatus = -1;
        }
        reduxDispatch(SET_EXAM_ELIGIBILITY(examStatus));
      }
    },
    [isAuth]
  );

  const links = useMemo(() => {
    const userLink = {
      text: `Hi, ${
        posData?.pos_data.full_name !== undefined || null || ''
          ? posData?.pos_data.full_name
          : storedObject?.full_name || 'Partner'
      }`,
      children: [
        {
          text: 'Profile',
          path: '/profile',
        },

        {
          text: 'Logout',
          path: '/',
          click: () => {
            sessionStorage.clear();
            localStorage.clear();
            reduxDispatch(SET_IS_AUTH(false));
          },
        },
      ],
    };

    const serviceLink = {
      text: 'Services',
      children: [
        {
          text: 'Renewal',
          path: '/renewal',
          children: {
            'Renewal Insurance': {
              logo: require('../../assets/images/menu/car.svg').default,
              children: [
                {
                  text: 'Upcoming Renewals',
                  path: 'renewal/upcoming-renewals',
                },
                {
                  text: 'Company Renewal Links',
                  path: 'renewal/company-renewal-links',
                },
              ],
            },
          },
        },
        {
          text: 'Claim',
          path: '/claim',
          // click: () => {
          //   sessionStorage.clear();
          //   localStorage.clear();
          //   reduxDispatch(SET_IS_AUTH(false));
          // },
        },
      ],
    };

    const authLinks = [
      // {
      //   text: 'Application',
      //   path: '/posp/details',
      // },

      {
        text: 'Training',
        path: '/posp/training',
      },
      {
        text: 'Exam',
        path: '/posp/exam',
        click: checkExamStatus,
      },

      { ...userLink },
    ];
    const businessinks = [
      {
        text: 'Products',
        // path: 'posp/products',
        children: {
          'Motor Insurance': {
            logo: require('../../assets/images/menu/car.svg').default,
            children: [
              {
                text: 'Private Car',
                path: 'posp/products/car-insurance',
              },
              {
                text: 'Two Wheeler Insurance',
                path: 'posp/products/two-wheeler-insurance',
              },

              {
                text: 'PCV Insurance',
                path: 'posp/products/pcv-insurance',
              },
              {
                text: 'GCV Insurance',
                path: 'posp/products/gcv-insurance',
              },
            ],
          },
          'Health Insurance': {
            logo: require('../../assets/images/menu/health.png'),
            children: [
              {
                text: 'Individual Health Insurance',
                path: InConstruction
                  ? '/under-construction'
                  : 'posp/products/health-insurance/individual',
              },
              {
                text: 'Family Health Insurance',
                path: InConstruction
                  ? '/under-construction'
                  : 'posp/products/health-insurance/family',
              },
              {
                text: 'Multi Individual Health Insurance',
                path: InConstruction
                  ? '/under-construction'
                  : 'posp/products/health-insurance/multi-individual',
              },
            ],
          },
          'Travel Insurance': {
            logo: require('../../assets/images/menu/travel.svg').default,
            children: [
              {
                text: 'Travel Insurance',
                path: InConstruction
                  ? '/under-construction'
                  : 'posp/products/travel-insurance',
              },
            ],
          },
          'Life Insurance': {
            logo: require('../../assets/images/menu/life.svg').default,
            children: [
              {
                text: 'Term Life Insurance',
                path: InConstruction
                  ? '/under-construction'
                  : 'posp/products/term-life-insurance',
              },
            ],
          },
        },
      },
      {
        text: 'Leads',
        new: true,
        path: '/posp/leads',
      },
      {
        text: 'Business',
        path: 'posp/business',
      },
      {
        text: 'Renewal',
        path: '/renewal',
        new: true,
        children: {
          'Renewal Insurance': {
            logo: require('../../assets/images/menu/car.svg').default,
            children: [
              {
                text: 'Upcoming Renewals',
                path: 'renewal/upcoming-renewals',
              },
              {
                text: 'Company Renewal Links',
                path: 'renewal/company-renewal-links',
              },
            ],
          },
        },
      },
      {
        text: 'Claim',
        path: '/claim',
      },
      // { ...serviceLink },
      {
        text: 'My Dashboard',
        path: 'posp/dashboard',
      },
      { ...userLink },
    ];
    const noAuthLinks = [
      {
        text: 'Home',
        path: '/',
      },
      // {
      //   text: 'Home 2',
      //   path: '/home-2',
      // },
      {
        text: 'About Us',
        path: '/about',
      },
      {
        text: 'Become POSP',
        path: '/posp/register',
      },
      {
        text: 'Contact Us',
        path: '/contact',
      },
      // {
      //   text: 'Login',
      //   path: '/posp/login',
      // },
      // {
      //   text: 'Whatsapp',
      //   path: '/posp/whatsapp',
      // },
    ];

    if (isAuth) {
      if (profileTrackerCode === 6) {
        return businessinks;
      } else if ([4, 5].includes(profileTrackerCode)) {
        return authLinks;
      } else {
        return [userLink];
      }
    } else {
      return noAuthLinks;
    }

    //   return isAuth
    //     ? profileTrackerCode === 6
    //       ? businessinks
    //       : [4, 5].includes(profileTrackerCode)
    //       ? authLinks
    //       : [userLink]
    //     : noAuthLinks;
  }, [isAuth, checkExamStatus, profileTrackerCode]);

  useEffect(() => {
    checkExamStatus();
  }, [checkExamStatus]);

  const [activeLink, setActiveLink] = useState(null);

  const handleLinkClick = (path, click) => {
    setActiveLink(path); // Update active link
    if (click) {
      click();
    }
    if (record) {
      navigate(path, { state: null });
      window.reload();
    }
  };

  return (
    links.length !== 0 && (
      <nav
        className={`${
          !toggle ? 'hidden' : ''
        } bg-white w-full pt-4 md:pt-0 md:w-auto md:flex md:items-center ${
          rounded ? 'rounded-xl' : 'rounded'
        }`}
      >
        <div
          className={`md:flex md:justify-end md:items-center whitespace-nowrap text-sm font-bold uppercase text-blue-900 w-full`}
        >
          {links.map((link) => {
            if ('children' in link) {
              return (
                <div
                  key={prefix + link.path}
                  onClick={() => handleLinkClick(link.path, link.click)}
                  className={`relative group md:px-4 block py-2 md:py-0 text-sm px-2 ${
                    activeLink === link.path
                      ? 'border-b-2 border-blue-500 '
                      : ''
                  }`}
                >
                  <button className="text-sm uppercase relative">
                    {link.text}
                    {link.new && <span className="curved-flag">NEW</span>}
                    <FontAwesomeIcon icon={faChevronDown} className="ml-2" />
                  </button>

                  <div className="z-[1000] md:absolute hidden bg-transparent py-2 text-black group-hover:block top-full md:left-1/2 md:-translate-x-1/2">
                    <div className="bg-white shadow-card rounded-md overflow-hidden">
                      {Object.prototype.toString.call(link.children) ===
                      '[object Object]' ? (
                        <div className="px-[46px] py-[64px] flex flex-wrap gap-4 max-h-full w-[40vw]">
                          {Object.keys(link.children).map((c, i) => (
                            <div key={prefix + c} className="last:pb-0 pb-2">
                              <div className="w-min grid grid-cols-[auto_auto] gap-2 items-center">
                                <img
                                  src={link.children[c].logo}
                                  alt={c}
                                  className="inline-block h-full min-h-[18px] max-w-[25px] max-h-[18px] object-contain"
                                />
                                <div className="">{c}</div>
                              </div>
                              {link.children[c].children.map((m) => (
                                <div
                                  key={m.path}
                                  className="py-2 w-full min-w-[130px] max-w-full font-normal text-xs capitalize text-left hover:bg-slate-50"
                                >
                                  <Link
                                    to={m.path}
                                    onClick={() =>
                                      handleLinkClick(m.path, m.click)
                                    }
                                    className={`text-sm px-2 ${
                                      activeLink === m.path
                                        ? 'border-b-2 border-blue-500'
                                        : ''
                                    }`}
                                  >
                                    {m.text}
                                  </Link>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      ) : (
                        link.children.map((li) => (
                          <div
                            key={prefix + li.path}
                            className="block py-3 px-4  min-w-[130px] shadow-sm font-medium capitalize text-center hover:bg-slate-50"
                          >
                            <Link
                              to={li.path}
                              onClick={() => handleLinkClick(li.path, li.click)}
                              className={`text-sm ${
                                activeLink === li.path
                                  ? 'border-b-2 border-blue-500'
                                  : ''
                              }`}
                            >
                              {li.text}
                            </Link>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <Link
                  key={prefix + link.path}
                  to={link.path}
                  onClick={() => handleLinkClick(link.path, link.click)}
                  className={`md:px-4 py-2 md:py-0 text-sm block relative ${
                    activeLink === link.path ? 'border-b-2 border-blue-500' : ''
                  }`}
                >
                  {link.text}
                  {link.new && <span className="curved1-flag">NEW</span>}
                </Link>
              );
            }
          })}
          {/* 🔹 Add Certificate Logo on the Right End */}
          {posData?.pos_data.cert || storedObject?.cert ? (
            <div className="ml-4 flex items-center">
              <Link to="/posp/training/certificate">
                <img
                  src={certificateLogo} // Replace with actual image path
                  alt="Certificate"
                  className="h-10 w-10 object-contain cursor-pointer"
                />
              </Link>
            </div>
          ) : (
            ''
          )}
        </div>
      </nav>
    )
  );
};

export default Navbar;
